import request from '@/utils/request'
import storage from 'store'
import { TENANT } from '@/store/mutation-types'

const ssoApi = {
  isLogin: '/sso/isLogin',
  getSsoAuthUrl: '/sso/getSsoAuthUrl',
  getLoginUserInfo: '/sso/getLoginUserInfo',
  loginByTicket: '/sso/loginByTicket',
  logout: '/sso/signout'
}

export function isLogin () {
  return request({
    url: ssoApi.isLogin,
    method: 'get'
  })
}

export function getSsoAuthUrl (parameter) {
  return request({
    url: ssoApi.getSsoAuthUrl,
    method: 'get',
    params: parameter
  })
}

export function getLoginUserInfo () {
  return request({
    url: ssoApi.getLoginUserInfo,
    method: 'get'
  })
}

export function loginByTicket (parameter) {
  return request({
    url: ssoApi.loginByTicket,
    method: 'post',
    data: parameter
  })
}

export function logout () {
  return request({
    url: ssoApi.logout,
    method: 'get'
  })
}
